(function () {
  Flint.file('views/womensResiCopy.js', function (require) {
    Flint.staticStyles('WomensResiCopy', {
      '$': '#_flintapp .ViewWomensResiCopy',
      '$img': '#_flintapp img.WomensResiCopy, #_flintapp .WomensResiCopy.img, #_flintapp .ViewWomensResiCopy.img, #_flintapp .WomensResiCopy > .img',
      '$bigRed': '#_flintapp bigRed.WomensResiCopy, #_flintapp .WomensResiCopy.bigRed, #_flintapp .ViewWomensResiCopy.bigRed, #_flintapp .WomensResiCopy > .bigRed',
      '$resiTitle': '#_flintapp resiTitle.WomensResiCopy, #_flintapp .WomensResiCopy.resiTitle, #_flintapp .ViewWomensResiCopy.resiTitle, #_flintapp .WomensResiCopy > .resiTitle',
      '$p': '#_flintapp p.WomensResiCopy, #_flintapp .WomensResiCopy.p, #_flintapp .ViewWomensResiCopy.p, #_flintapp .WomensResiCopy > .p',
      '$li': '#_flintapp li.WomensResiCopy, #_flintapp .WomensResiCopy.li, #_flintapp .ViewWomensResiCopy.li, #_flintapp .WomensResiCopy > .li'
    }, {
      '$': {
        fontFamily: 'helvetica neue'
      },
      '$img': {
        minHeight: 0
      },
      '$bigRed': {
        marginTop: 20,
        marginBottom: 20,

        fontSize: 32
      },
      '$resiTitle': {
        display: 'inline',
        fontStyle: 'italic',
        fontWeight: 'bold'
      },
      '$p': {
        lineHeight: 1.7,
        margin: [0, 0, 20]
      },
      '$li': {
        lineHeight: 1.7,
        marginBottom: 20
      }
    });
    Flint.view('WomensResiCopy', function (view, on, $) {
      var context = initContext(view, {
        colors: atom(),
        width: atom()
      });
      var pro = initPro(view, {});

      var copyWidth = derivation(function () {
        console.log('width', pro.style.get().get('width'));
        return Math.min(500, pro.style.get().get('width'));
      });view.render(function () {
        return view.el(
          ['wrapper', 1],
          null,
          view.el(
            ['p', 1],
            null,
            'First things first, I want to congratulate you on making the smartest decision you could make in your dating life, and giving Enchant Mr. Right™ the chance it deserves. This is going to transform you into the kind of woman that gets (and keeps) the man of her choice.'
          ),
          view.el(
            ['p', 2],
            null,
            'Now here’s a question for you. How would you like to suddenly possess the almost-magical ability to “cast your spell” on any man you talk to… within seconds of meeting him?'
          ),
          view.el(
            ['p', 3],
            null,
            'The reason I ask you this is because many of my best female students are a lot like me. They’re a tad impatient, and they want to get results quickly and easily… without spending months studying a course and then going out and looking for opportunities to practice.'
          ),
          view.el(
            ['bigRed', 1],
            null,
            'And That\'s Why I Know You\'re Going To Love This'
          ),
          view.el(
            ['p', 4],
            null,
            'You see, when it comes to finding and keeping love, you don’t want to waste years trying to get things right. And sure, Enchant Mr. Right™ is going to get you there much more quickly than you would if you were just doing trial-and-error.'
          ),
          view.el(
            ['p', 5],
            null,
            'But what if you didn’t have to do it alone? What if you could actually achieve a year’s worth of results using Enchant Mr. Right™…'
          ),
          view.el(
            ['p', 6],
            null,
            '…in just 2 days?'
          ),
          view.el(
            ['p', 7],
            null,
            'Imagine what it would be like to possess all the skills you need to:'
          ),
          view.el(
            ['ul', 1],
            null,
            view.el(
              ['li', 1],
              null,
              'Approach any man you want and easily start a conversation with him (instead of waiting around to be approached like all the other girls).'
            ),
            view.el(
              ['li', 2],
              null,
              'Easily keep the conversation going, and enjoy the fact that he’s becoming more and more fascinated by you with each and every minute that goes by.'
            ),
            view.el(
              ['li', 3],
              null,
              'Enjoy the attention of all the highest quality bachelors at any social gathering and leave all the other women wondering what your secret was. You’ll be that one special girl that the men just can’t stop thinking about and wanting to know more about.'
            ),
            view.el(
              ['li', 4],
              null,
              'Never again have to worry about men only wanting you for sex. No more getting friend-zoned or any of those “friends with benefits” relationships unless YOU want them. The men you date are going to be serious about being with you, and ONLY you.'
            ),
            view.el(
              ['li', 5],
              null,
              'Bask in the glow of his intense love for you, and secretly giggle when he tries to convince you to be in a monogamous relationship. You’ll look back and wonder why getting a man to commit was ever a struggle now that you’ve got these tools.'
            )
          ),
          view.el(
            ['bigRed', 2],
            null,
            'Let Me Personally Help You Achieve All Of This In Just 2 Amazing Days'
          ),
          view.el(['img', 1], { src: '/images/womensresi/1.jpg' }),
          view.el(
            ['p', 8],
            null,
            'I’ve spent more than 10 years studying attraction and relationships… and coaching people how to interact with the opposite sex in every type of environment. The men and women who have come and trained with me here in Hollywood have completely transformed their lives, and the results they’re getting back in their hometowns is astounding to everyone else around them.'
          ),
          view.el(
            ['p', 9],
            null,
            'Why does live training work so well? It’s pretty simple. The reason I’m so good at what I do is because I’ve literally interacted with tens of thousands of women. I’ve made every possible mistake, learned from it, refined my theories, and now I’ve literally got this thing down to a science.'
          ),
          view.el(
            ['p', 10],
            null,
            'Here’s what that means for you: It means that when you and I go out and socialize together, I’ll be able to instantly pick out what you’re doing right and what needs adjusting. This is the kind of real world, instant feedback that NOBODY can ever give you.'
          ),
          view.el(
            ['p', 11],
            null,
            'Why? Because they simply aren’t qualified to give that feedback because they lack the experience and don’t have the “trained eye” that me and my coaches do. Also, they simply don’t know how to give that kind of feedback in a way that feels good and encourages you to try something new.'
          ),
          view.el(
            ['p', 12],
            null,
            'The men you’ve been dating would rather just leave and disappear without ever telling you the REAL reason why they left. That sucks! I always hated it when that happened to me, and so I committed myself to making sure that doesn’t happen to anyone ever again.'
          ),
          view.el(
            ['p', 13],
            null,
            'Here’s how I’m going to help you with all of this:'
          ),
          view.el(
            ['bigRed', 3],
            null,
            'Introducing...'
          ),
          view.el(
            ['p', 14],
            null,
            view.el(
              ['resiTitle', 1],
              null,
              'The Enchant Mr. Right™ Weekend'
            ),
            ' – A 2-Day Immersion Experience That Completely Transforms The Way You Interact With Men, And Empowers You To Finally Get The Result You Want In Relationships!'
          ),
          view.el(
            ['p', 15],
            null,
            'This isn’t some watered-down, motivational weekend seminar. In fact, there is nothing like this for women on the face of the earth. Here’s how it works:'
          ),
          view.el(
            ['p', 16],
            null,
            'You’ll arrive Saturday morning and meet the instructors. First, we’ll take the time to get to know you better and discuss where you feel stuck with men and what kind of results you want. This is important, because my instructors want to get you the best possible results during this weekend, so we like to get to know you before we begin.'
          ),
          view.el(
            ['p', 17],
            null,
            'Then we jump straight into a semi-private seminar for you and the other Enchant Mr. Right™ students. This is where we pull back the curtains and reveal our top-secret methods for talking to men in a way that stimulates them emotionally. This is THE most crucial skill to have, and we make sure you really get it.'
          ),
          view.el(
            ['p', 18],
            null,
            'Then we dive into a series of fun drills, exercises, and games to help “install” the skills into your brain so they become automatic. It’s important to drill these skills first so that you can just relax and enjoy yourself when you practice out in the real world.'
          ),
          view.el(['img', 2], { src: '/images/womensresi/2.jpg' }),
          view.el(
            ['p', 19],
            null,
            'For example, you\'ll learn things like:'
          ),
          view.el(
            ['ul', 2],
            null,
            view.el(
              ['li', 6],
              null,
              'Word-for-word - EXACTLY what to say to a man when you want to start a conversation. And the best part? He’ll think he’s the one who started talking to you!'
            ),
            view.el(
              ['li', 7],
              null,
              'Simple exercises to train your brain to keep the conversation going without strain, struggle, or effort. After day 1, you’ll wonder why this ever felt hard for you in the past.'
            ),
            view.el(
              ['li', 8],
              null,
              'How to flirt with him without coming across as too aggressive or “try hard”. In fact, the more you use our flirting techniques, the more intrigued he’ll become with you and the harder he’ll work to get you.'
            ),
            view.el(
              ['li', 9],
              null,
              'How to instantly “delete” the fear of rejection so you can just go out and have a blast without any fear or anxiety getting in your way.'
            ),
            view.el(
              ['li', 10],
              null,
              'What to say when you want to deflect his sexual advances (for now), but also keep him interested in you. This one technique will give you the confidence to know that he’ll still be into you even if sex doesn’t happen quickly (this has been a welcome relief for so many women).'
            ),
            view.el(
              ['li', 11],
              null,
              'And so much more! The bottom line is that you’ll learn how to handle just about every situation that comes up with the grace and ease of a desirable, confident woman that any man would kill to be with.'
            )
          ),
          view.el(
            ['p', 20],
            null,
            'And that’s actually the next part of Saturday. We go out to one of the hottest and most fun social venues in the Hollywood area and practice talking to guys in this new way. You are going to LOVE this part. The place we take our students is overflowing with friendly, interesting, and attractive people, and I promise you’ll have the time of your life.'
          ),
          view.el(
            ['p', 21],
            null,
            'This is where those drills we did earlier that day will come into play. You’ll be shocked as you hear yourself saying and doing the right things all night long. You’ll be flirting, smiling, and having a great time as you surprise yourself with how witty and charming you’ve become.'
          ),
          view.el(
            ['bigRed', 4],
            null,
            'And That’s Just The First Day!'
          ),
          view.el(
            ['p', 22],
            null,
            'Once we begin on Sunday, we’ll debrief what happened the day before. We’ll share stories and high five each other for a job well done (and also learn from our mistakes, of course). But the learning isn’t over yet. We dive straight into the second seminar where you’ll learn all about having relationships using the Enchant Mr. Right™  techniques.'
          ),
          view.el(['img', 3], { src: '/images/womensresi/3.jpg' }),
          view.el(
            ['p', 23],
            null,
            'There are 5 main components to Sunday’s seminar, and they are:'
          ),
          view.el(
            ['p', 24],
            null,
            view.el(
              ['b', 1],
              null,
              'Part 1 - Communication'
            ),
            ' - You’ll discover our 2 biggest secrets to compassionate communication. This is the foundation for having a fulfilling relationship that meets both your needs and gives you the love you really want.'
          ),
          view.el(
            ['p', 25],
            null,
            view.el(
              ['b', 2],
              null,
              'Part 2 - Personality Type'
            ),
            ' - There are 3 main personality typing systems we endorse, and you’ll learn how to see yourself through each one. This is by far the fastest method of self-discovery there is. Prepare to have your eyes open and to be surprised at just how amazing you are. You’ll discover how to play to your strengths and overcome any old weaknesses that are inherent to your type. This part of the seminar is a LOT of fun!'
          ),
          view.el(
            ['p', 26],
            null,
            view.el(
              ['b', 3],
              null,
              'Part 3 - World View'
            ),
            ' - Even the best communication techniques cannot overcome fundamental differences in worldview. We’ll show you how to quickly discover your own world view according to our system, and then also discover his so you can test for true compatibility. This is where the rubber meets the road. You’ll learn how to find out if you’re actually compatible with him, rather than just hoping you are.'
          ),
          view.el(
            ['p', 27],
            null,
            view.el(
              ['b', 4],
              null,
              'Part 4 - Stages Of Relationship Growth'
            ),
            ' - We’ll provide you with an complete and easy-to-follow map of what every couple goes through while getting closer. What’s great about this is that once you understand the predictable process of bonding, you’ll be ready for any challenges that come up and work through them easily.'
          ),
          view.el(
            ['p', 28],
            null,
            view.el(
              ['b', 5],
              null,
              'Part 5 - Sex'
            ),
            ' - This is the cherry on top of your amazing weekend experience with us. We’ll reveal some of the most powerful techniques for connecting sexually with a man. We draw from many disciplines including tantra to teach you to trigger deep, sexual polarity in your man. Once you start using our techniques, he won’t be able to resist you… now or ever. He will be yours and you will be his… deeply connected and enjoying a lifetime of pleasure.'
          ),
          view.el(
            ['p', 29],
            null,
            'So now you know why...'
          ),
          view.el(
            ['bigRed', 5],
            null,
            'This Is The Fastest Possible Way To Get Good Mind-Blowing Results With Men!'
          ),
          view.el(
            ['p', 30],
            null,
            'Listen, I want to emphasize something. You made a wise decision by investing in Enchant Mr. Right™. This is the best self-study program for women on how to captivate and keep the kind of man you really want and deserve.'
          ),
          view.el(
            ['p', 31],
            null,
            'But I want to emphasize something else as well. It’s a SELF-study program, which means you’re on your own, and it’s up to you to get the results you want. If you want faster results (MUCH faster), than the absolute best way to get them is to come to one of our intensive weekends.'
          ),
          view.el(
            ['p', 32],
            null,
            'There’s no other way on earth to make progress happen this quickly. Our coaches are specially trained to quickly catch the most common mistakes women make when talking to men and gently correct them on the spot!  What if there was one tiny bad habit that you never realized you were doing… and that bad habit was what kept causing men to not give you the level of love and commitment you deserve?'
          ),
          view.el(['img', 4], { src: '/images/womensresi/4.jpg' }),
          view.el(
            ['p', 33],
            null,
            'And what if we could knock any and all bad habits out during your time with us? How would that change your life and your luck with the opposite sex? Listen, I’ve been doing this for over 10 years, and I’ve seen people’s lives completely shift in the area of love and relationships all because I fixed one or two simple things in how they were communicating.'
          ),
          view.el(
            ['p', 34],
            null,
            'In other words… the instant, personal feedback you get is priceless!'
          ),
          view.el(
            ['bigRed', 6],
            null,
            'So How Much Does The Spellbound Weekend Cost?'
          ),
          view.el(
            ['p', 35],
            null,
            'To be completely honest with you… in the end it really doesn’t cost anything, and here’s why. Think of all those nights you’ve gone out, paid cover charges, bought drinks and dinners, and still never got the results you were hoping for. Or all the money you’ve spent on nice outfits, dresses, makeup, etc… and yet still haven’t landed that one special man you’ve always wanted.'
          ),
          view.el(
            ['p', 36],
            null,
            'So if you added up the cost of all that, it’s way more than I would ever charge for this life-changing weekend with me.'
          ),
          view.el(
            ['p', 37],
            null,
            'Okay, so how much then? A lot less than you’d think. Remember when I told you that I’ve been studying relationships and attraction and coaching men for 10 years, and they come and stay with me for an entire week? Well depending on the package they choose, they end up paying between $5,000 and $10,000 for a week with me and my instructors.'
          ),
          view.el(
            ['p', 38],
            null,
            'But you don’t have to pay that much. In fact, if I was only charging half of the lowest possible price of $5,000… you’d only be looking at $2,500, but guess what? You won’t even pay that much. In fact, you won’t even pay half of THAT. Listen, I promise this is totally affordable. In fact, it’s honestly a bargain for the quality of private training you’ll be getting.'
          ),
          view.el(['img', 5], { src: '/images/womensresi/5.jpg' }),
          view.el(
            ['p', 39],
            null,
            'The bottom line is this. When you go to social gatherings, you don’t want to get caught up in that game where all the women are competing with their looks.'
          ),
          view.el(
            ['p', 40],
            null,
            'Yuck! Who wants that?'
          ),
          view.el(
            ['p', 41],
            null,
            'In order to stand out from the other women out there and land an amazing man who wants you for MORE than just your looks, you have to learn how to stimulate him emotionally when you talk to him.'
          ),
          view.el(
            ['bigRed', 7],
            null,
            'That’s What This Weekend Is All About!'
          ),
          view.el(
            ['bigRed', 8],
            null,
            'Gaining Skills With Men That You Can Use For A Lifetime!'
          ),
          view.el(
            ['p', 42],
            null,
            'So are you ready to finally do something for yourself and say “yes” to getting this part of your life handled, once and for all? Would you like to know that you can walk into any room and easily attract the attention of the best men available? Would you like to enjoy interacting with men in a whole new way that gets you far better results… and even the man of your dreams?'
          ),
          view.el(
            ['p', 43],
            null,
            'Then I invite you to join us at Enchant Mr. Right™ Weekend. In order to be considered for the weekend, we need to actually speak with you on the phone to make sure it’s a good fit for the both of us.'
          ),
          view.el(
            ['p', 44],
            null,
            'So go ahead and fill out the form below, and one of my senior coaches will contact you within 24 hours to go over the details with you and help you get ready for your weekend experience. I have to say… I can’t wait to meet you and help you attract that special someone into your life.'
          ),
          view.el(
            ['p', 45],
            null,
            'All that’s left to do is fill out the form now to get the process started. As you probably know, my show on Yahoo! is taking off and more and more women are learning about this. We can only take on a handful of women at each weekend, so be sure to fill out the application now so we can get you in as soon as possible.'
          ),
          view.el(
            ['p', 46],
            null,
            'Go ahead and do that now, and I look forward to meeting you soon.'
          ),
          view.el(
            ['p', 47],
            null,
            view.el(
              ['i', 1],
              null,
              '–Mehow'
            )
          )
        );
      });

      $["$"] = function (_, _index) {
        return { maxWidth: copyWidth.get()
        };
      };

      $["img"] = function (_, _index) {
        return {
          maxWidth: copyWidth.get() };
      };

      $["bigRed"] = function (_, _index) {
        return { color: context.colors.get().accent };
      };

      $["resiTitle"] = function (_, _index) {
        return { color: context.colors.get().accent
        };
      };
    });
  })
})();
//# sourceMappingURL=womensResiCopy.js.map
